<div class="page-container">
  <mat-card>
    <h1>Welcome to Table Flip Games!</h1>
    <h2>Choose the game you want to play... </h2>
    <mat-list role="list">
      <mat-list-item role="listitem"><a class="link" (click)="openDialog('trivia')">Trivia Game</a></mat-list-item>
      <mat-list-item role="listitem"><a class="link" (click)="openDialog('telesketchpad')">Tele-Sketchpad Game</a></mat-list-item>
      <mat-list-item role="listitem"><a class="link" (click)="openDialog('liars-dice')">Liar's Dice Game</a></mat-list-item>
      <mat-list-item role="listitem"><a class="link" (click)="openDialog('scattergories')">Scattergories Game</a></mat-list-item>
    </mat-list>
  </mat-card>

  <mat-card>Players go to <a href="//alpha.tableflip.games/login" target="_blank"><strong>BIT.LY/TBLFLP</strong></a> on your favorite browser to join in on the fun!</mat-card>
  <mat-card>
    <div class="home-instructions">
      <h3>How to Play</h3>
      <ol></ol>
      <p>This page is the "board" or "host" page, keep this page open so you can see the state of the game you are playing.</p>
      <p>All players go to: <a href="//alpha.tableflip.games/login" target="_blank"><strong>BIT.LY/TBLFLP</strong></a> on your browser and you can connect to the game.</p>
      <p>Choose a game you want to play and you will receive a room code for everyone to be able to connect to.</p>
      <p>Each game will have their own instructions and rules.</p>
      <p>Play your friends and have fun!</p>
      </div>
  </mat-card>
  <mat-card>
    <img src="../../assets/images/table-flip-bg.png" />
  </mat-card>
</div>

